export const allBranchesSelector = (state) => state.branchReducer.allBranches;
export const branchDetailBySlugSelector = (state) =>
  state.branchReducer.branchDetailBySlug;
